export default function Footer() {
  const linkStyle = {
    color: 'var(--color-primary)',
    textDecoration: 'none',
    fontSize: '0.9rem'
  }

  return (
    <footer className="footer">
      <div className="container">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem' }}>
            <strong style={{ color: 'var(--color-text)' }}>🔒 Privacy First</strong>
            {' — All processing happens in your browser'}
          </div>
          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
            <a href="/" style={linkStyle}>All Tools</a>
            <a href="https://aicoding.club/docs/course/" style={linkStyle}>Docs</a>
            <a href="https://aicoding.club/blog" style={linkStyle}>Blog</a>
            <a href="https://github.com/IsaacZhaoo/ai-coding-club/discussions" target="_blank" rel="noopener noreferrer" style={linkStyle}>Community</a>
          </div>
          <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.85rem' }}>
            © <span suppressHydrationWarning>{new Date().getFullYear()}</span> AI Coding Club · Built with ❤️
          </div>
        </div>
      </div>
    </footer>
  )
}
